import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import btnStyles from "../../styles/Button.module.css";
import billingStyles from "../../styles/BillingPage.module.css";
import supportStyles from "../../styles/SupportTickets.module.css";
import PaymentMethodFormFields from "./PaymentMethodFormFields";

export default function AddPaymentMethodModal({
  show,
  title,
  saving,
  message,
  cardElementOptions,
  onHide,
  onSubmit,
}) {
  const [billingDetails, setBillingDetails] = useState({
    addressLine1: "",
    country: "",
    state: "",
    city: "",
    postalCode: "",
  });

  useEffect(() => {
    if (!show) {
      setBillingDetails({
        addressLine1: "",
        country: "",
        state: "",
        city: "",
        postalCode: "",
      });
    }
  }, [show]);

  const handleBillingDetailsChange = (event) => {
    const { name, value } = event.target;

    setBillingDetails((previousDetails) => ({
      ...previousDetails,
      [name]: value,
      ...(name === "country" ? { state: "" } : {}),
    }));
  };

  const handleFormSubmit = (event) => {
    onSubmit(event, billingDetails);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      scrollable
      className={supportStyles.SupportModal}
      dialogClassName={supportStyles.ModalWide}
    >
      <Form onSubmit={handleFormSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={supportStyles.ModalBodyScroll}>
          <p className={`${billingStyles.Subtitle} mb-3`}>
            Enter your card details below. Your card will be saved securely for
            subscription and future payments.
          </p>
          <PaymentMethodFormFields
            cardElementOptions={cardElementOptions}
            billingDetails={billingDetails}
            onBillingDetailsChange={handleBillingDetailsChange}
            disabled={saving}
          />
          {message && (
            <Alert variant="danger" className="mt-3 mb-0">
              {message}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            className={`${btnStyles.Button} ${btnStyles.GreyDark}`}
            onClick={onHide}
            disabled={saving}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save card"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
